export class User {
 
    id: number;
    fName: string = "";
    lName: string = "";
    signUpType:"generic";
    socialLoginId:string = "";
    socialLoginType:"generic";
    email: string = "";
    mobile:number;
    user:number;
    address:string;
    state:string;
    city:string;
    pinCode:number;
    gender: number;
    DLfront:string;
    DLback:string;
    DLnumber:string;
    idProof:string;
    otherProof:string;
    otherDetails:string;
    status:number;
    mobileVerified:number;
    emailVerified:number;
    referalCode:string;
    createdAt:Date;
    updatedAt:Date;
    createdBy:string;
    password: string;
    otp:number;
    username:string;
    price:string;
    penaltyCharge:number;
    constructor(values: Object = {}) {
      //Constructor initialization
      Object.assign(this, values);
  }
 
}


// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/User.ts